import { render, staticRenderFns } from "./SnippetHero.vue?vue&type=template&id=d1647702"
import script from "./SnippetHero.vue?vue&type=script&lang=js"
export * from "./SnippetHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SnippetHeroHeadlines: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetHeroHeadlines.vue').default,BasicVideo: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicVideo.vue').default,SnippetHeroImages: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetHeroImages.vue').default})
